import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import moment from 'moment'
import { IoAlertCircleOutline, IoClose } from 'react-icons/io5'
import './Assinatura.css'

// ─────────────────────────────────────────────────────────────────────────────
//  Aviso de assinatura no painel (loja do cadastro self-serve e, desde os
//  avisos automáticos, a loja de CONTRATO com fatura vencida no Asaas)
//
//  Pergunta à API (GET /assinatura/resumo — leve, sem Asaas) ao abrir o painel:
//   - em atraso → faixa com a data-limite e o botão "Pagar agora";
//   - suspensa/encerrada (bloqueou com o painel aberto) → leva para
//     /assinatura, onde a loja regulariza ou reativa.
//  Fechar a faixa vale só para esta sessão do navegador.
// ─────────────────────────────────────────────────────────────────────────────

export default function AvisoAssinatura() {
    const [aviso, setAviso] = useState(null)
    const location = useLocation()

    useEffect(() => {
        let vivo = true
        fetch(process.env.REACT_APP_BASE_URL + '/assinatura/resumo', {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('nekb') }
        })
            .then((r) => r.json())
            .then((r) => {
                if (!vivo || !r || (!r.self_serve && !r.contrato)) return
                if (r.bloqueada) {
                    localStorage.setItem('viewType', 'bloqueado')
                    window.location.href = '/assinatura'
                    return
                }
                let fechado = false
                try { fechado = sessionStorage.getItem('ass_aviso_fechado') === (r.situacao && r.situacao.vencimento) } catch (e) { /* sem storage */ }
                if (r.situacao && r.situacao.codigo === 'em_atraso' && !fechado) setAviso({ ...r.situacao, contrato: !!r.contrato })
            })
            .catch(() => null)
        return () => { vivo = false }
    }, [])

    if (!aviso || location.pathname === '/assinatura') return null
    const limite = moment(aviso.suspende_em).subtract(1, 'day').format('DD/MM')
    const fechar = () => {
        try { sessionStorage.setItem('ass_aviso_fechado', aviso.vencimento) } catch (e) { /* sem storage */ }
        setAviso(null)
    }
    return (
        <div className="ass-banner" role="status">
            <IoAlertCircleOutline size={22} />
            <span>{aviso.contrato ? 'Sua fatura BIWAPP venceu em ' : 'Sua mensalidade venceu em '}<strong>{moment(aviso.vencimento).format('DD/MM')}</strong>. Pague até <strong>{limite}</strong> para evitar a suspensão da conta.</span>
            {/* contrato: as faturas em aberto (com o link do Asaas) ficam em Meu plano */}
            <Link to={aviso.contrato ? '/plano' : '/assinatura'} onClick={() => setAviso(null)}>Pagar agora</Link>
            <button type="button" onClick={fechar} aria-label="Fechar aviso"><IoClose size={18} /></button>
        </div>
    )
}
